/**
 * Document revision stage configuration
 * Domain-specific constants for document workflow stages
 */

import { DocumentRevisionStatus, DocumentRevisionStatusLabels } from '@/shared/lib';

export type DocumentStageListItem = {
  label: string;
  value: string;
};

let _stageList: DocumentStageListItem[] | null = null;

export function getStageList(): readonly DocumentStageListItem[] {
  if (!_stageList) {
    _stageList = [
      {
        label: DocumentRevisionStatusLabels[DocumentRevisionStatus.PENDING_APPROVAL],
        value: DocumentRevisionStatus.PENDING_APPROVAL,
      },
      {
        label: DocumentRevisionStatusLabels[DocumentRevisionStatus.APPROVED],
        value: DocumentRevisionStatus.APPROVED,
      },
      {
        label: DocumentRevisionStatusLabels[DocumentRevisionStatus.PENDING_VERIFICATION],
        value: DocumentRevisionStatus.PENDING_VERIFICATION,
      },
      {
        label: DocumentRevisionStatusLabels[DocumentRevisionStatus.FAILED_APPROVAL],
        value: DocumentRevisionStatus.FAILED_APPROVAL,
      },
    ];
  }
  return _stageList;
}

export const STAGE_LIST = new Proxy([], {
  get(_, prop) {
    const list = getStageList();
    if (prop === 'length') return list.length;
    if (typeof prop === 'string' && !isNaN(Number(prop))) return list[Number(prop)];
    return (list as any)[prop];
  },
}) as unknown as readonly DocumentStageListItem[];
